import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createShiftRule = async (data) => {
  const res = await axiosInstance.post("/api/payroll-portal/shift-rule", data);
  return res.data;
};

export const getAllShiftRules = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/shift-rule");
  return res.data;
};

export const updateShiftRule = async (id, data) => {
  const res = await axiosInstance.put(`/api/payroll-portal/shift-rule/${id}`, data);
  return res.data;
};
